import { Tabs } from '@alf/uikit';
import { LocalizedNavLink, useLocation } from '@namespace/i18n';

const WithdrawTypeSelector = ({ tabs, activeTabIdx = 0 }) => {
  const { pathname } = useLocation();
  return (
    <Tabs
      list={tabs}
      activeTabIndex={activeTabIdx}
      pathname={pathname}
      LocalizedNavLink={LocalizedNavLink}
    />
  );
};

export default WithdrawTypeSelector;
